import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconChurnRate: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.6249 7.075C7.02633 7.075 8.1624 5.93892 8.1624 4.5375C8.1624 3.13608 7.02633 2 5.6249 2C4.22348 2 3.0874 3.13608 3.0874 4.5375C3.0874 5.93892 4.22348 7.075 5.6249 7.075Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M12.8749 7.075C14.2763 7.075 15.4124 5.93892 15.4124 4.5375C15.4124 3.13608 14.2763 2 12.8749 2C11.4735 2 10.3374 3.13608 10.3374 4.5375C10.3374 5.93892 11.4735 7.075 12.8749 7.075Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M2 16.5C2 16.1778 2 15.0903 2 13.2375C2 11.2355 3.36671 9.61255 5.05265 9.61255C5.86668 9.61255 6.4772 9.61255 6.88421 9.61255C8.36503 9.61255 9.25003 11.0723 9.25003 11.0723"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 16.5C16.5 16.1778 16.5 15.0903 16.5 13.2375C16.5 11.2355 15.117 9.61255 13.4111 9.61255C12.5873 9.61255 11.9696 9.61255 11.5577 9.61255C10.1217 9.61255 9.24718 11.0723 9.25001 11.0723"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.5376 15.05H14.3251"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9824 13.6936L13.4318 14.1457L14.3305 15.0499L13.4318 15.9784L12.9824 16.4427"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.74438 13.6843L5.28792 14.1388L4.375 15.0476L5.28792 15.9715L5.74438 16.4335"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
